var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.8,203.1H312.3V8.4c0-4.6-3.7-8.3-8.3-8.3h-89.5c-4.6,0-8.3,3.7-8.3,8.3V203H8.3c-4.6,0-8.3,3.7-8.3,8.3v89.4 c0,4.6,3.7,8.3,8.3,8.3h197.8v194.6c0,4.6,3.7,8.3,8.3,8.3h89.4c4.6,0,8.3-3.7,8.3-8.3V309.1h191.5c4.6,0,8.3-3.7,8.3-8.3v-89.4 C512.1,206.8,508.4,203.1,503.8,203.1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Plus.b28bdb78991fca455fc0890e9037aaf8.svg";